import script from "./Videos.vue?vue&type=script&lang=ts&setup=true"
export * from "./Videos.vue?vue&type=script&lang=ts&setup=true"

import "./Videos.vue?vue&type=style&index=0&id=d6b8eee4&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6b8eee4"]])

export default __exports__